var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"manager-header",attrs:{"color":"headerPrimary"}},[_c('a',{attrs:{"href":_vm.logoLink,"target":"_blank"}},[_c('img',{staticClass:"manager-header-logo",attrs:{"alt":"Captura Yearbooks","src":_vm.logo}})]),_c('div',{staticClass:"manager-header-name"},[_vm._v(_vm._s(_vm.user.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }